if (!window.cardVisCategoryRowsInitialized) {
  window.cardVisCategoryRowsInitialized = true;

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-category-row-products]').forEach((list) => {
      const sliderComponent = list.closest('slider-component');
      const resetSliderPosition = () => {
        list.scrollLeft = 0;
        if (typeof sliderComponent?.resetPages === 'function') {
          sliderComponent.resetPages();
        }
      };

      resetSliderPosition();
      requestAnimationFrame(() => requestAnimationFrame(resetSliderPosition));
      window.addEventListener('pageshow', resetSliderPosition, { once: true });
    });
  });
}
